import api from "@/api/"
import auth from "@/modules/auth/api/"
import { loadLanguageAsync } from "@/locales/setup.js"

const consoleStyle = "background: lightgreen; color: black"

export default {
	/**
	 * @description When CRM is launched, we have to init a client
	 * and set all settings for him
	 */
	async init({ state, commit, dispatch }) {
		console.log("%cInit client...", consoleStyle)

		commit("ADD_LOADING")

		// Set preferred locales based on what's in localStorage
		dispatch("setLocale", window.localStorage["covergo-locale"] || "en-US")

		// Get settings for this user and populate global store
		await dispatch("fetchSettings")

		// Get permissions for this user
		await dispatch("me")

		// If there is no settings, show error to user
		if (!state.settings || !state.permissions) {
			commit("SET_NONEXISTENT_SETTINGS", true)
			commit("REMOVE_LOADING")
			return Promise.reject(new Error())
		}

		// Set settings for particular features
		// commit(
		// 	"clients/SET_SETTINGS",
		// 	JSON.parse(JSON.stringify(state.settings.clients))
		// )

		// Init is finalized
		// commit("SET_IS_READY", true)
		commit("REMOVE_LOADING")
		return Promise.resolve()
	},

	setLocale({ commit }, locale) {
		commit("ADD_LOADING")

		loadLanguageAsync(locale).then(() => {
			commit("REMOVE_LOADING")
		})
	},

	async fetchSettings({ state, commit }) {
		const { tenantId } = state

		if (!tenantId) return Promise.resolve()

		const res = await api.settings.get({ tenantId })

		if (!res.errors) {
			// Massage settings
			// listing sections of settings into actual fields
			let settings = res.data

			commit("SET_SETTINGS", settings)
			console.log("%cSettings successfully fetched", consoleStyle)
			return Promise.resolve()
		}
	},

	async me({ state, commit }) {
		const res = await auth.me()

		if (!res.errors) {
			if (res.data.me.targettedPermissions) {
				// Fetch permissions
				commit("SET_PERMISSIONS", res.data.me.targettedPermissions)
				console.log("%cPermissions successfully fetched", consoleStyle)

				// If associatedUser has no name, case for admin account
				if (res.data.me.associatedUser === null) {
					commit("SET_USERNAME", null)
				}
				// If associatedUser has a name, save in global store
				else commit("SET_USERNAME", res.data.me.associatedUser.name)

				// Fetch and save users email to global store
				commit("SET_EMAIL", res.data.me.email)
				console.log("%cUsername and Email successfully fetched", consoleStyle)

				return Promise.resolve()
			}
		}

		return Promise.resolve()
	},

	addMessage({ commit }, { message, delay = 10000, preventAutoClose = false }) {
		commit("ADD_MESSAGE", message)

		// Automatically remove messages after a few seconds
		if (preventAutoClose === false) {
			const timeout = setTimeout(message => {
				commit("REMOVE_MESSAGE", message)
				clearTimeout(timeout)
			}, delay)
		}
	},

	/**
	 * It will display first error from received errors
	 * @param errors - Array of Strings that contain error messages from api
	 */
	showError({ dispatch }, errors) {
		// Iterate through array of errors and show the first one
		if (errors.length === 0) return

		let message =
			typeof errors === "string"
				? errors
				: typeof errors[0] === "string"
				? errors[0]
				: errors[0]?.errors[0] || "Something went wrong"

		dispatch("addMessage", {
			message: { type: "error", text: message }
		})
	},

	/**
	 * It will display first error from received errors
	 * @param errors - Array of Strings that contain error messages from api
	 */
	showWarning({ dispatch }, errors) {
		// Iterate through array of errors and show the first one
		if (errors.length === 0) return

		let message = typeof errors === "string" ? errors : errors[0]

		dispatch("addMessage", {
			message: { type: "warning", text: message }
		})
	},

	/**
	 * It will display success message
	 * @param {String} - message to display
	 */
	showSuccess({ dispatch }, msg) {
		dispatch("addMessage", {
			message: { type: "success", text: msg }
		})
	},

	// Will add message that this feature is not supported in demo
	thisFeatureNotSupported({ dispatch }) {
		dispatch("addMessage", {
			message: {
				type: "warning",
				text: "This feature is not supported in DEMO mode."
			}
		})
	}
}
